import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikActions, FormikProps } from 'formik';
import { mergeFields, processApiError } from 'common/utils/form';

import { AppState } from 'common/models/AppState';
import { MemberApi } from 'common/api/resources/MemberApi';
import { Member } from 'common/api/models/Member';
import { FormInput } from 'common/components/form/FormInput';
import { toApiError } from 'common/utils/api';
import { Product } from 'common/api/models/Product';
// import moment = require('moment');

interface MemberDialogProps {
  member?: Member;
  isOrg: boolean;
  appState: AppState;
  allProducts: Product[];
  onSave: (id: string) => void;
  onCancel: () => void;
}
class MemberFormValues {
  learnDashProductId = 'NONE';
}

export class MemberLDActionDialog extends React.Component<MemberDialogProps> {
  validationSchema = Yup.object().shape({
    learnDashProductId: Yup.string(),
  });

  initialValues = () => {
    return this.props.member
      ? mergeFields(new MemberFormValues(), {
          ...this.props.member,
          ...this.props.member.vars,
        })
      : new MemberFormValues();
  };
  handleSendLDApproveEmail = () => {
    const user = this.props.member;
    if (user && user.email) {
      this.setState({ dialogLoading: true });
      MemberApi.sendLearndashApproval({ email: user.email }).then(
        res => {
          this.setState({
            dialogSuccess: 'Email sent to ' + user.email + '.',
            dialogError: undefined,
            dialogLoading: false,
          });
        },
        err => {
          this.setState({ dialogError: toApiError(err), dialogSuccess: undefined, dialogLoading: false });
        }
      );
    }
  };

  handleSubmit = (values: MemberFormValues, actions: FormikActions<MemberFormValues>) => {
    const member = this.props.member!;
    let memberData: Member = {
      vars: {
        learnDashProductId: values.learnDashProductId,
      },
    };
    if (!member.id) {
      memberData = {
        ...memberData,
        type: this.props.isOrg ? Member.Type.ORG : Member.Type.USER,
      };
    }
    const call = member.id ? MemberApi.updateMember(member.id, memberData) : MemberApi.createMember(memberData);
    call.then(
      res => {
        if (values.learnDashProductId !== 'NONE') {
          this.handleSendLDApproveEmail();
        }
        this.props.onSave(member.id ? member.id : (res as any).id);
        actions.setSubmitting(false);
        actions.setStatus(undefined);
      },
      err => {
        processApiError(err, actions);
      }
    );
  };

  render() {
    const props = this.props;
    const isOrg = props.isOrg;
    const title = 'Membership Approval';
    return (
      <Modal size="lg" isOpen={!!props.member} toggle={props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<MemberFormValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>{title}</ModalHeader>
              <ModalBody>
                {!isOrg && (
                  <div className="row">
                    <div className="col">
                      <FormInput
                        id="learnDashProductId"
                        name="learnDashProductId"
                        label="Learn-Dash Access"
                        tag="select"
                        value={form.values.learnDashProductId}
                        onChange={form.handleChange}
                      >
                        <option key="0" disabled={true} value="NONE">
                          NONE
                        </option>
                        {this.props.allProducts &&
                          this.props.allProducts.map((p, i) => {
                            return (
                              <option key={p.id} value={p.id ? p.id : 0}>
                                {p.name}
                              </option>
                            );
                          })}
                      </FormInput>
                    </div>
                  </div>
                )}

                {form.status && <div className="alert alert-danger">{form.status}</div>}
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/MemberLDActionDialog.tsx